import React from "react";

export default function VehicleDeliveryReportChecking({ data, loading, children }) {
  return <div>{children}</div>;
}
